import { type BasicCouponFragment, type BasicServiceFragment, ServiceCategory } from '@drycut/graphql';

type Props = {
  coupon: BasicCouponFragment | undefined;
  services: Array<BasicServiceFragment>;
  tax?: number;
};

// Computes the booking price based on the selected services and coupon. The coupon only applies
// to the haircut service, additional services are always charged in full.
export function computeBookingPrice({ tax = 0, services, coupon }: Props): number {
  const haircutService = services.find((service) => service.category === ServiceCategory.Haircut);
  const otherServices = services.filter((service) => service.category !== ServiceCategory.Haircut);

  // If there is a coupon and the coupon price is 0, the haircut is free. Otherwise the coupon
  // price replaces the haircut price.
  const haircutPrice = coupon ? coupon.price : haircutService?.price || 0;

  const additionalServicesPrice = otherServices.reduce(
    (total, service) => total + service.price,
    0,
  );

  return haircutPrice + additionalServicesPrice + tax;
}
